// extracted by mini-css-extract-plugin
export var fileExt = "_uo-8";
export var fileIcon = "_uo-6";
export var fileLink = "_uo-5";
export var fileName = "_uo-7";
export var image = "_uo-1";
export var imageError = "_uo-3";
export var imageErrorIcon = "_uo-4";
export var imageLink = "_uo-0";
export var imageLoaded = "_uo-2";